import {UIGameMechanic} from '../UIGameEventController'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import {UIGameManager} from '../UIGameManager'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {UIGameAddAchievementEvent, UIGameAchievementEventEmitter} from '@colonist/ui-game'

export class UIGameAchievementController implements UIGameMechanic {
    protected readonly uiGameManager: UIGameManager

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.PlayerReceivedAchievement: this.achieve(data); break
            default: break
        }
    }

    // eslint-disable-next-line class-methods-use-this
    private achieve(options: UIGameAddAchievementEvent) {
        UIGameAchievementEventEmitter.emit('addAchievement', options)
    }
}
